






































import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import { PluginMixin } from '@spa/mixins/plugin'

import SpaCharacter from '@/components/organisms/Character.vue'
import CancelIndicator from '@spa/components/organisms/indicator/CancelIndicator.vue'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    CancelIndicator,
    SpaCharacter,
  },
})
export default class HistoryDetailCanceled extends Mixins<PluginMixin>(PluginMixin) {
  showModal: boolean = false
  modalMessage: string = ''

  beforeRouteEnter(to, from, next) {
    const { id } = to.params

    if (from.path !== `/mypage/order/${id}/cancel`) {
      next({
        path: `/mypage/order/${id}`,
        replace: true,
      })

      return
    }

    next()
  }
}
